import { createSlice } from "@reduxjs/toolkit";
import { fetchGroups, saveGroup, deleteGroup } from "../actions/groupsActions";

const initialState = {
    groups: [],
    loading: false,
    error: null,
};

const groupsSlice = createSlice({
    name: "groups",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchGroups.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchGroups.fulfilled, (state, action) => {
                state.loading = false;
                state.groups = action.payload.data ?? action.payload;
            })
            .addCase(fetchGroups.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(saveGroup.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(saveGroup.fulfilled, (state, action) => {
                state.loading = false;
                state.dashs = [...state.groups, action.payload];
            })
            .addCase(saveGroup.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deleteGroup.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteGroup.fulfilled, (state, action) => {
                state.loading = false;
                state.groups = state.groups.filter(d => d.uid !== action.payload);
            })
            .addCase(deleteGroup.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default groupsSlice.reducer;